/**
 * Shared patterns for detecting reference candidates in guide documents.
 * These patterns are used both for highlighting in the editor and for collecting candidates.
 */
export const REFERENCE_CANDIDATE_PATTERNS = {
  figures: [/(?:Figur|fig\.)\s(\d{1,3}(?:\s[a-z](?![a-z]))?)/gi],
  tables: [/Tabell\s(\d{1,3}(?:\s[a-z](?![a-z]))?)/gi],
  headings: [/(?:Punkt|pkt\.)\s(\d{1,3})/gi, /\[(\d{1,3})\]/g],
  guides: [/\d{3}\.\d{3}\b/g, /BVN\s\d{2}\.\d{3}\b/gi],
  standards: [/NS(?:-EN)?(?:\s(?:ISO|IEC)(?:\/IEC)?)?\s\d+(?:-\d+)?/gi],
} as const;

/**
 * Extract the numbering portion from a candidate text using the pattern's capture group.
 * E.g. "Tabell 12 a" → "12 a", "Figur 3" → "3", "pkt. 12" → "12", "[5]" → "5"
 */
export function extractNumbering(candidateText: string, category: 'tables' | 'figures' | 'headings'): string | null {
  for (const pattern of REFERENCE_CANDIDATE_PATTERNS[category]) {
    const match = new RegExp(pattern.source, pattern.flags).exec(candidateText);
    if (match?.[1]) return match[1];
  }
  return null;
}
